<template>
  <div :class="rootClass">
    <slot />
  </div>  
</template>

<script>

export default {
  name: 'Drawer',

  props: {
    open: Boolean,

    origin: {
      type: String,
      default: 'left'
    }
  },

  computed: {
    rootClass () {
      return [
        this.$style.root,
        this.$style[`origin-${this.origin}`],
        { [ this.$style.open ]: this.open }
      ]
    }
  }
}

</script>

<style module>

.root {
  position: fixed;
  z-index: 1000;

  /* TODO: ANIMATION_UPDATE */
  visibility: hidden;

  /* this might not be so easily overwriteable */
  min-width: 25%;

  @apply
    h-full
    bg-white
    border-0
    border-r
    border-solid
    border-dull;
}

.open {
  visibility: visible;  
}

.origin-left {
  left: 0;
  top: 0;
}

.origin-right {
  right: 0;
  top: 0;
}

.origin-top {
  top: 0;
  left: 0;
}

.origin-bottom {
  bottom: 0;
  left: 0;
}

</style>
